import "@fontsource/bebas-neue/400.css";
import "@fontsource/outfit/300.css";
import "@fontsource/outfit/400.css";
import "@fontsource/outfit/500.css";
import "@/App.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AudioProvider } from "@/context/AudioContext";
import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AudioToggle } from "@/components/AudioToggle";
import { EntryScreen } from "@/components/EntryScreen";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Producer from "@/pages/Producer";

function Shell() {
  useLenis();
  return (
    <div className="App relative">
      <div className="grain-overlay animate-grain" aria-hidden="true" />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/producer" element={<Producer />} />
      </Routes>
      <Footer />
      <EntryScreen />
      <AudioToggle />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

function App() {
  return (
    <AudioProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </AudioProvider>
  );
}

export default App;
